import React, { useEffect } from 'react';

/* External */
import { Route } from 'react-router-dom';

/* Project */
import { ReactReduxContext } from 'config/configureStore';
import Layout from 'commons/containers/Layout';
import Permits from 'utils/permits';
import Paths from 'utils/paths';
import { canAccessModule, getAccessPolicy, getCurrentSubdomain } from 'utils/accessPolicy';

function CustomRedirect({ to }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);

  return null;
}

function PrivateRoute({ zendesk, component: Component, user, ...rest }) {
  return (
    <Route
      path={Paths[rest.module]}
      exact={rest.exact}
      component={() => {
        const isLoggedIn = Boolean(user && rest.role);

        // 1. Si no está logueado, redirigir al login
        if (!isLoggedIn) {
          return <CustomRedirect to="/auth/oauth2" />;
        }

        const isOnlySchedule = rest.permissions && rest.permissions.includes('schedule_management');
        const isScheduleModule = rest.module === 'SCHEDULE_MANAGEMENT';
        const accessPolicy = getAccessPolicy({
          subdomain: getCurrentSubdomain(),
          roleName: rest.role?.name,
        });
        
        // Usamos ?. para Permits por seguridad al ya haber validado la sesión
        const hasRole = Permits[rest.module]?.includes(rest.role.name) || (rest.module === 'FEATURE_FLAGS' && user?.email === 'gonzalo@tcit.cl');
        const hasPermission = !rest.requiredPermission || (rest.permissions && rest.permissions.includes(rest.requiredPermission));
        const hasPolicyAccess = canAccessModule(rest.module, accessPolicy);

        // 2. Si está logueado, tiene el rol, tiene el permiso de schedule_management y NO estamos en la ruta de schedule 
        if (hasRole && isOnlySchedule && !isScheduleModule) {
           return <CustomRedirect to="/scheduleManagement" />;
        }

        // 3. De lo contrario, renderizamos el componente (solo si tiene los permisos necesarios)
        return hasRole && hasPermission && hasPolicyAccess ? (
          <Layout zendesk={zendesk}>
            <Component context={ReactReduxContext} />
          </Layout>
        ) : (
          <CustomRedirect to="/" />
        );
      }}
    />
  );
}

export default PrivateRoute;
